import React, {Component} from 'react';
import {Button, Container, Header, Icon, Image} from 'semantic-ui-react';
import {Link} from "react-router-dom";

const icon = require('../../img/icons/upgrade_account.svg');

class UpgradeAccount extends Component {
    render() {
        return (
            <Container textAlign='center'>
                <Header as='h1' icon textAlign='center'>
                    <Icon><Image centered src={icon} style={{width:'7em'}} alt='logo'/></Icon>
                </Header>
                <Button size='large' icon='rocket' labelPosition='left' as={Link} to='/settings/suscription' primary content='Actualizar Plan!'/>
            </Container>
        );
    }
}

export default UpgradeAccount;



// WEBPACK FOOTER //
// ./src/components/extras/UpgradeAccount.js